import { render, staticRenderFns } from "./ReqCompraFormComponent.vue?vue&type=template&id=9126c0b8&"
import script from "./ReqCompraFormComponent.vue?vue&type=script&lang=js&"
export * from "./ReqCompraFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports